import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';

@Component({
    selector: 'app-login-from-phone',
    templateUrl: './login-from-phone.component.html',
    styleUrls: ['./login-from-phone.component.scss'],
    standalone: false
})
export class LoginFromPhoneComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
showWebFallback = false;
  constructor( private languageTranslateService: LanguageTranslateService) { 
    super()

  }

  ngOnInit(): void {
    this.push( this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
      }
    }))
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

openAppStore() {
  // Replace with your real App Store URL
  // e.g., 'https://apps.apple.com/app/id1234567890'
  window.open(' https://apps.apple.com/my/app/fieldex/id1500554195', '_blank', 'noopener');
}

openPlayStore() {
  // Replace with your real Play Store URL
  // e.g., 'https://play.google.com/store/apps/details?id=com.fieldex.app'
  window.open('https://play.google.com/store/apps/details?id=com.custella.workforce.android', '_blank', 'noopener');
}

}
